import '@ant-design/compatible/assets/index.css';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import Partner from '~pages/dashboard/referral/partner/list';

@withTranslation()
class PartnerPage extends React.Component {
  constructor() {
    super();

    this.state = {};
  }

  render() {
    return <Partner />;
  }
}

export default PartnerPage;

PartnerPage.propTypes = {
  t: PropTypes.func,
  history: PropTypes.object,
  auth: PropTypes.shape({
    currentRoleSlug: PropTypes.string,
  }),
  cmsUser: PropTypes.object,
};

PartnerPage.defaultProps = {
  t: () => {},
  history: '',
  auth: {},
  cmsUser: {},
};
